import { useState, useEffect } from "react";

/**
 * Hook to manage pagination logic.
 */
export const usePagination = (totalItems: number, itemsPerPage: number = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages || 1);
    }
  }, [totalPages, currentPage]);

  const paginatedIndices = {
    start: (currentPage - 1) * itemsPerPage,
    end: currentPage * itemsPerPage,
  };

  return {
    currentPage,
    setCurrentPage,
    totalPages,
    paginatedIndices,
  };
};